import { IEnvironment } from './i-environment';

export const environment: IEnvironment = {
  moduleName: '#{spa.sandbox.environment.modulename}#',
  uniqueName: '#{spa.sandbox.environment.moduleScope}#',
  remoteEntryUrl: '#{spa.sandbox.environment.remoteEntryurl}#',
  uiUrl: '#{spa.sandbox.environment.uiurl}#',
  apiUrl: '#{spa.environment.apiUrl}#',
  msalScope: '#{spa.environment.msalScope}#',
  msalAuthority: '#{spa.environment.msalAuthority}#',
  msalClientId: '#{spa.environment.msalClientId}#',
  msalPostLogoutRedirectUri: '#{spa.environment.msalPostLogoutRedirectUri}#',
  production: '#{spa.environment.production}#'.toLowerCase() === 'true',
};
